import React from 'react';
import Header from 'cccisd-header';
import style from './style.css';

const Fortress = window.cccisd.fortress;
const userType = Fortress.user.acting.data_type;

const HeaderComponent = () => {
    let logoLink = '/';
    const getPrimaryNavLinks = () => {
        let primaryNavLinks = [];
        if (userType === 'uberadmin') {
            logoLink = '/manage';
            primaryNavLinks = [
                {
                    url: '/data',
                    label: 'Data',
                },
                { url: '/healingSystemsCourse', label: 'Course' },
                { url: '/resourcecenter', label: 'Resources' },
                { url: '/resources/admin', label: 'Resource Admin' },
                { url: '/appdefs/logs', label: 'System Logs' },
                { url: '/siteContent', label: 'Edit Site Content' },
                { url: '/manage', label: 'Manage' },
            ];
        }
        if (userType === 'orgAdmin') {
            logoLink = '/overview';
            primaryNavLinks = [
                { url: '/overview', label: 'Overview' },
                { url: '/orgAssessment', label: 'Organization Assessment' },
                { url: '/healingSystemsCourse', label: 'Course' },
                { url: '/resourcecenter', label: 'Resources' },
                { url: '/manage', label: 'Manage' },
            ];
        }
        if (userType === 'orgTeamMember') {
            logoLink = '/overview';
            primaryNavLinks = [
                { url: '/overview', label: 'Overview' },
                { url: '/orgAssessment', label: 'Organization Assessment' },
                { url: '/healingSystemsCourse', label: 'Course' },
                { url: '/resourcecenter', label: 'Resources' },
            ];
        }
        if (userType === 'learner') {
            logoLink = '/healingSystemsCourse';
            primaryNavLinks = [
                { url: '/healingSystemsCourse', label: 'Course' },
                { url: '/resourcecenter', label: 'Resources' },
            ];
        }

        return primaryNavLinks;
    };

    const primaryNavLinks = getPrimaryNavLinks();

    return (
        <Header
            containerClassName="container-fluid"
            wrapperClassName={style.wrapper}
            logoClassName={style.logo}
            logoLink={logoLink}
            primaryNavLinks={primaryNavLinks}
            showHomeAction={false}
            showAlertAction={false}
            showAdminAction={Fortress.hasRole('uberadmin')}
            loginButtonText="Register | Login"
        />
    );
};

export default HeaderComponent;
